module.exports = __webpack_public_path__ + "04_long_gold.67533645.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_long_gold.png
// module id = OMUA
// module chunks = 0